var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{directives:[{name:"track",rawName:"v-track",value:({ name: 'toDownload' }),expression:"{ name: 'toDownload' }"}],staticClass:"download-top-container",on:{"click":_vm.toDownload}})}
var staticRenderFns = []

export { render, staticRenderFns }